import { typeData } from 'src/pages/TaskDefinition/components/TaskHandlerConfig';

import type { TaskDefinition } from 'src/generated/graphql';

export default function isHumanTask(type: TaskDefinition['type']): boolean {
    return !!typeData[type].isHumanTask;
}
